import React from "react";
import "./style.less";
import User from "./nav-user";
// import Message from "./nav-msg";
/* eslint-disable */
class Nav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let headerCrumb = [
      {
        name: "升级套餐",
        href: "/v3/homepage/pricing"
      },
      {
        name: "开放平台",
        href: "/v3/homepage/developer"
      },
      {
        name: "反馈中心",
        href: "/v3/feedback/list"
      },
      { name: "快站大学", href: "https://m.kuaizhan.com/90/3/p2649405090dde7" }
    ];

    let pulldownList = [
      {
        dataName: "site",
        href: "/v3/site/",
        name: "建站"
      },
      {
        dataName: "vote",
        href: "/vote/backend.html",
        name: "投票"
      }
    ];
    return (
      <header className="kz-header-new">
        <div className="header-container">
          <section className="header-left">
            <a href="/" className="kz-logo">
              <span className="logo-new" />
            </a>
          </section>
          <section className="header-center">
            <div className="header-pulldown">
              <div className="pulldown-btn">
                <span className="header-pulldown-text">建站</span>
                <span className="iconfont icon-youjiantou1" />
              </div>
              <div className="pulldown-content">
                <div className="pulldown-triangle" />
                <ul className="pulldown-list">
                  {pulldownList.map((item, index) => {
                    return (
                      <li
                        data-name={item.dataName}
                        key={index}
                        className="pulldown-item"
                      >
                        <a href={item.href} className="item-link">
                          <div className="link-text-wrap">
                            <div className="link-text">{item.name}</div>
                          </div>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </section>
          <section className="header-right">
            <nav className="header-crumb">
              {headerCrumb.map((item, index) => {
                return (
                  <div className="header-crumb-item" key={index}>
                    <a href={item.href}>{item.name}</a>
                  </div>
                );
              })}
            </nav>
            <div className="header-cell header-help">
              <a href="https://wiki.kuaizhan.com/pub/%E9%A6%96%E9%A1%B5" target="_blank">
                <span className="iconfont icon-bangzhu" />
              </a>
            </div>
            {/* <Message /> */}
            <User />
          </section>
        </div>
      </header>
    );
  }
}

export default Nav;
